import { postSubscription } from "@/api/apply/apply";

export async function startAlimProcess(
  userInfo: UserInfo,
  course: string,
  setShowModal: (state: boolean) => void,
  setStep?: (nextStep: string) => void
) {
  // const onlineUserId = userInfo ? userInfo._id : null;
  // const { success } = await postSubscription(onlineUserId, course);
  // if (success && setStep) {
  setStep("essentialInfo");
  // }

  // if (!success && setStep) {
  //   setStep("alreadyAlimCompleted");
  // }

  // if (onlineUserId) {
  setShowModal(true);
  // }
}
